'use strict';

const {Observable, from, of} = require('rxjs');
const {mergeMap} = require('rxjs');
const {fn} = require('iblokz-data');

const openDialog = cb => {
	let fileEl = document.createElement('input');
	fileEl.setAttribute('type', 'file');
	fileEl.addEventListener('change', ev => {
		console.log(ev.target.files, this);
		cb(
			ev.target.files
		);
	});
	fileEl.dispatchEvent(new MouseEvent('click', {
		view: window,
		bubbles: true,
		cancelable: true
	}));
};

const load = (file, readAs = 'text') => new Observable(subscriber => {
	const fr = new FileReader();
	fr.onload = function(ev) {
		subscriber.next(
			readAs === 'json'
				? JSON.parse(ev.target.result)
				: ev.target.result
		);
		subscriber.complete();
	};
	((typeof file === 'string')
		? from(fetch(file)).pipe(mergeMap(res => from(res.blob())))
		: of(file))
		.subscribe(f => fn.switch(readAs, {
			arrayBuffer: f => fr.readAsArrayBuffer(f),
			default: f => fr.readAsText(f)
		})(f));
});

module.exports = {
	openDialog,
	load
};
